// hooks/useFetchSubSubjects.js
import { useState, useEffect } from "react";
import { getAllsubSubject } from "../services/getAllSubSubject";

export function useFetchSubSubjects() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const allData = await getAllsubSubject();
        setData(allData);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  return { data, loading, error };
}